"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogin = void 0;
const react_1 = require("react");
const useRequest_1 = require("./useRequest");
const hmac_sha256_1 = __importDefault(require("crypto-js/hmac-sha256"));
const enc_base64_1 = __importDefault(require("crypto-js/enc-base64"));
const helpers_1 = require("./helpers");
const ui_1 = require("@rahtab/ui");
const helpers_2 = require("./helpers");
const TokenAuthContext_1 = __importDefault(require("./TokenAuthContext"));
const moment_jalaali_1 = __importDefault(require("moment-jalaali"));
const useLogin = () => {
    const [getChallengeLoading, setGetChallengeLoading] = react_1.useState(true);
    const [challengeTime, setChallengeTime] = react_1.useState(moment_jalaali_1.default());
    const [loginLoading, setLoginLoading] = react_1.useState(false);
    const [serverChallenge, setChallenge] = react_1.useState(0);
    const alert = ui_1.useAlert();
    const request = useRequest_1.useRequest();
    const { handleSuccessfulLogin } = react_1.useContext(TokenAuthContext_1.default);
    console.log('challenge is:', serverChallenge);
    react_1.useEffect(() => {
        (async () => {
            await getChallengeAsync();
        })();
    }, []);
    const getChallengeAsync = async () => {
        return new Promise((resolve, reject) => {
            request('GetServerChallenge', { useAuthJson: false })
                .then((challenge) => {
                setChallenge(challenge);
                setChallengeTime(moment_jalaali_1.default());
                setGetChallengeLoading(false);
                resolve(challenge);
            })
                .catch((e) => {
                setGetChallengeLoading(false);
                reject(e);
            });
        });
    };
    const login = async (username, password) => {
        setLoginLoading(true);
        const challengeDiffTime = moment_jalaali_1.default().diff(challengeTime, 'minutes');
        let challenge = serverChallenge;
        if (challengeDiffTime > 5) {
            challenge = await getChallengeAsync();
        }
        const digest = encodeURIComponent(hmac_sha256_1.default(helpers_1.fixNumbers(password), challenge.toString()).toString(enc_base64_1.default));
        try {
            const loginData = await request('Login', {
                params: `UserName=${helpers_1.fixNumbers(username)}&Digest=${digest}`,
                useAuthJson: false,
                numberOfRetry: 1,
            });
            console.log('loginData:', loginData);
            if (Array.isArray(loginData)) {
                const sessionToken = hmac_sha256_1.default(challenge.toString(), helpers_1.fixNumbers(password)).toString(enc_base64_1.default);
                const session10 = sessionToken.slice(0, 10);
                await helpers_1.setTokensInStorage(loginData);
                await helpers_2.storeSessionToken(session10, username);
                setLoginLoading(false);
                handleSuccessfulLogin();
            }
            else {
                setLoginLoading(false);
                alert({
                    title: 'خطا',
                    message: 'نام کاربری یا رمز عبور نادرست است.',
                });
            }
        }
        catch (err) {
            setLoginLoading(false);
        }
    };
    return { getChallengeLoading, loginLoading, login };
};
exports.useLogin = useLogin;
